import { getSupportData } from "@/api/faq";
import React, { useEffect, useState } from "react";
import "./Accreditation.css";
import HousingWireLogo from "../../../public/assets/svg/faq/HousingWireLogo";
import BBBLogo from "../../../public/assets/svg/faq/BBBLogo";
import NAALogo from "../../../public/assets/svg/faq/NAALogo";

const Accreditation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [faqCmsData, setFAQCmsData] = useState(null);

  useEffect(() => {
    const fetchHelpTopics = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await getSupportData("faqSection");
        setFAQCmsData(result.results[0]);
      } catch (error) {
        setError("Failed to fetch help topics. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchHelpTopics();
  }, []);

  return (
    <div className="stats-banner">
      {faqCmsData != null && (
        <>
          <div>
            <div className="heading-one">{faqCmsData?.accreditationTitle}</div>
            <div className="heading-two">
              {faqCmsData?.accreditationTitleBold}
            </div>
          </div>
          <div>
            <div className="heading-three">~{faqCmsData?.registeredUser}</div>
            <div className="heading-four">million registered users</div>
          </div>
          <span className="stats-divider" />
          <div>
            <div className="heading-three">{faqCmsData?.properties}</div>
            <div className="heading-four">properties</div>
          </div>
          <span className="stats-divider" />
          <div>
            <div className="heading-three">{faqCmsData?.homesSold}</div>
            <div className="heading-four">homes sold</div>
          </div>
          <div>
            <div className="heading-five">Member</div>
            <div>
              <NAALogo />
            </div>
          </div>
          <div>
            <div className="heading-five">Winner</div>
            <div>
              <HousingWireLogo />
            </div>
          </div>
          <div>
            <div>
              <BBBLogo />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Accreditation;
